import { Box, Button, IconButton } from "@mui/material";
import React from "react";
import ClearIcon from "@mui/icons-material/Clear";

const VideoPreviewComponent = ({
  VideoPreview,
  setVideoPreview,
  index,
  videoFiles,
  setVideoFiles,
  setDeletedVideos,
  editTableVideos,
}) => {
  const [cancel, setCancel] = React.useState(false);
  // "";

  return (
    <Box className="video-preview-wrapper">
      <IconButton
        className="cancel-btn"
        onClick={() => {
          /// change video file state to remove videos
          setVideoFiles(videoFiles.filter((_, i) => i !== index));
          setDeletedVideos((prev) => {
            const matched = editTableVideos.filter(
              (video) => video.video == VideoPreview
            );
            if (matched.length > 0) {
              prev.push(matched[0].id);
            }
            return prev;
          });
        }}
      >
        <ClearIcon sx={{ color: "black", fontSize: "22px" }} />
      </IconButton>
      <video
        className="video-preview"
        controls
        muted
        src={VideoPreview}
        style={{ display: cancel ? "none" : "block" }}
      />
    </Box>
  );
};

export default VideoPreviewComponent;
